import React, { useMemo } from 'react';
import { renderRichHtml } from '../utils/media';

// Affiche le contenu HTML d'un article ou d'une page, avec les vidéos YouTube en lecteur intégré
export default function RichContent({ html, className }) {
  const rendered = useMemo(() => renderRichHtml(html), [html]);
  return <div className={className} dangerouslySetInnerHTML={{ __html: rendered }} />;
}
